import axios from 'axios';

const getEnabledListingCountForAppointmentDesk = async (
  subscriptionType: 'org' | 'user',
): Promise<{
  count: number;
}> => {
  const { data } = await axios.get<{ count: number }>(
    `/listing/appointment_desk/${subscriptionType}/count`,
  );
  return data;
};

export default getEnabledListingCountForAppointmentDesk;
